import { AppShell } from "@/components/shell/AppShell";
import { SessionGate } from "@/components/auth/SessionGate";
import { useAccountSession } from "@/hooks/useAccountSession";
import Attention from "@/pages/Attention";
import Landing from "@/pages/Landing";

export const RootShell = () => {
  const session = useAccountSession();
  return <SessionGate session={session} guest={<Landing />}><AppShell /></SessionGate>;
};
export const RootIndex = () => <Attention />;
